import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  index: number;
  classList: string[];
  animation: boolean;
}


import { computed, defineComponent } from 'vue';

export type Instance = InstanceType<
  typeof import('./ModalBackdrop.vue').default
>;

const __default__ = defineComponent({ name: 'ModalBackdrop' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    index: null,
    classList: null,
    animation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  index: number;
  classList: string[];
  animation: boolean;
};

/** `ModalBackdrop` component properties. */


/** ... */
const zIndex = computed(() => 1040 + props.index + props.index * 10);
/** ... */
const transitionDuration = computed(() => (props.animation ? '0.15s' : '0'));

return { __sfc: true,props, zIndex, transitionDuration }
}

})